export enum StopsDetailsLevel {
    /** Level 0 (stops pins hidden) */
    L0 = 'hide',
    /** Level 1 (stops pins hidden) */
    L1 = 'show'
}
